<template>
    <div class="section">
        <div class="section_wrap row rehab_list_wrap">
            <h6 class="--blue70 mb10">{{ $t('rehabilitation.list') }}</h6>
            <div
                v-if="patientInfoProps.check"
                style="margin-top: -30px;"
            >
              <div class="right_add_list_btn pointer right_btn" @click="$modal.show('add-edit-exercise-modal', {type : 'add'})">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" v-tooltip="this.$t('rehabilitation.add')"
                     width="24" height="24"
                     viewBox="0 0 172 172"
                     style=" fill:#000000;">
                <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g id="original-icon" fill="#275cbb" opacity="0" visibility="hidden"><path d="M21.5,32.25c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75zM57.33333,35.83333c-2.58456,-0.03655 -4.98858,1.32136 -6.29153,3.55376c-1.30295,2.2324 -1.30295,4.99342 0,7.22582c1.30295,2.2324 3.70697,3.59031 6.29153,3.55376h93.16667c2.58456,0.03655 4.98858,-1.32136 6.29153,-3.55376c1.30295,-2.2324 1.30295,-4.99342 0,-7.22582c-1.30295,-2.2324 -3.70697,-3.59031 -6.29153,-3.55376zM21.5,75.25c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75zM57.33333,78.83333c-2.58456,-0.03655 -4.98858,1.32136 -6.29153,3.55376c-1.30295,2.2324 -1.30295,4.99342 0,7.22582c1.30295,2.2324 3.70697,3.59031 6.29153,3.55376h93.16667c2.58456,0.03655 4.98858,-1.32136 6.29153,-3.55376c1.30295,-2.2324 1.30295,-4.99342 0,-7.22582c-1.30295,-2.2324 -3.70697,-3.59031 -6.29153,-3.55376zM21.5,118.25c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75zM57.33333,121.83333c-2.58456,-0.03655 -4.98858,1.32136 -6.29153,3.55376c-1.30295,2.2324 -1.30295,4.99342 0,7.22582c1.30295,2.2324 3.70697,3.59031 6.29153,3.55376h93.16667c2.58456,0.03655 4.98858,-1.32136 6.29153,-3.55376c1.30295,-2.2324 1.30295,-4.99342 0,-7.22582c-1.30295,-2.2324 -3.70697,-3.59031 -6.29153,-3.55376z"></path></g><g id="subtracted-icon" fill="#275cbb"><path d="M32.25,43c0,5.93706 -4.81294,10.75 -10.75,10.75c-5.93706,0 -10.75,-4.81294 -10.75,-10.75c0,-5.93706 4.81294,-10.75 10.75,-10.75c5.93706,0 10.75,4.81294 10.75,10.75zM150.5,35.83333c2.58456,-0.03655 4.98858,1.32136 6.29153,3.55376c1.30295,2.2324 1.30295,4.99342 0,7.22582c-1.30295,2.2324 -3.70697,3.59031 -6.29153,3.55376h-93.16667c-2.58456,0.03655 -4.98858,-1.32136 -6.29153,-3.55376c-1.30295,-2.2324 -1.30295,-4.99342 0,-7.22582c1.30295,-2.2324 3.70697,-3.59031 6.29153,-3.55376zM32.25,86c0,5.93706 -4.81294,10.75 -10.75,10.75c-5.93706,0 -10.75,-4.81294 -10.75,-10.75c0,-5.93706 4.81294,-10.75 10.75,-10.75c5.93706,0 10.75,4.81294 10.75,10.75zM150.5,78.83333c2.58456,-0.03655 4.98858,1.32136 6.29153,3.55376c1.30295,2.2324 1.30295,4.99342 0,7.22582c-0.12906,0.22112 -0.26892,0.43366 -0.41869,0.63712c-6.18476,-2.73207 -13.02143,-4.25003 -20.20617,-4.25003c-9.43612,0 -18.27186,2.61833 -25.81889,7.16667h-53.01445c-2.58456,0.03655 -4.98858,-1.32136 -6.29153,-3.55376c-1.30295,-2.2324 -1.30295,-4.99342 0,-7.22582c1.30295,-2.2324 3.70697,-3.59031 6.29153,-3.55376zM32.25,129c0,5.93706 -4.81294,10.75 -10.75,10.75c-5.93706,0 -10.75,-4.81294 -10.75,-10.75c0,-5.93706 4.81294,-10.75 10.75,-10.75c5.93706,0 10.75,4.81294 10.75,10.75zM57.33333,136.16667c-2.58456,0.03655 -4.98858,-1.32136 -6.29153,-3.55376c-1.30295,-2.2324 -1.30295,-4.99342 0,-7.22582c1.30295,-2.2324 3.70697,-3.59031 6.29153,-3.55376l30.7522,0c-1.35665,4.54325 -2.08553,9.35473 -2.08553,14.33333z"></path></g><g><g id="Layer_1" fill="#275cbb"><path d="M136.16667,100.33333c-19.78717,0 -35.83333,16.04617 -35.83333,35.83333c0,19.78717 16.04617,35.83333 35.83333,35.83333c19.78717,0 35.83333,-16.04617 35.83333,-35.83333c0,-19.78717 -16.04617,-35.83333 -35.83333,-35.83333zM150.5,143.33333h-7.16667v7.16667c0,3.956 -3.21067,7.16667 -7.16667,7.16667c-3.956,0 -7.16667,-3.21067 -7.16667,-7.16667v-7.16667h-7.16667c-3.956,0 -7.16667,-3.21067 -7.16667,-7.16667c0,-3.956 3.21067,-7.16667 7.16667,-7.16667h7.16667v-7.16667c0,-3.956 3.21067,-7.16667 7.16667,-7.16667c3.956,0 7.16667,3.21067 7.16667,7.16667v7.16667h7.16667c3.956,0 7.16667,3.21067 7.16667,7.16667c0,3.956 -3.21067,7.16667 -7.16667,7.16667z"></path></g><g id="Rounded" fill="#000000" opacity="0"><path d="M86,136.16667c0,-27.66333 22.50333,-50.16667 50.16667,-50.16667c27.66333,0 50.16667,22.50333 50.16667,50.16667c0,27.66333 -22.50333,50.16667 -50.16667,50.16667c-27.66333,0 -50.16667,-22.50333 -50.16667,-50.16667z"></path></g></g></g></svg>
              </div>
              <div>
                <input type="file" ref="fileInput" style="display: none;" @change="selectProtocolFile">
                <div class="right_add_list_btn pointer right_btn">
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" v-tooltip="this.$t('rehabilitation.add_protocol')" @click="openFileInput"
                      width="24" height="24"
                      viewBox="0 0 24 24" 
                      style=" fill:#000000;">
                      <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M20,18H19V17a1,1,0,0,0-2,0v1H16a1,1,0,0,0,0,2h1v1a1,1,0,0,0,2,0V20h1a1,1,0,0,0,0-2Zm-7,2H6a1,1,0,0,1-1-1V5A1,1,0,0,1,6,4h5V7a3,3,0,0,0,3,3h3v3a1,1,0,0,0,2,0V9s0,0,0-.06a1.31,1.31,0,0,0-.06-.27l0-.09a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19.29.29,0,0,0-.1,0A1.1,1.1,0,0,0,12.06,2H6A3,3,0,0,0,3,5V19a3,3,0,0,0,3,3h7a1,1,0,0,0,0-2ZM13,5.41,15.59,8H14a1,1,0,0,1-1-1ZM8,8a1,1,0,0,0,0,2H9A1,1,0,0,0,9,8Zm5,8H8a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2Zm1-4H8a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z" fill="#275cbb"/></g>
                  </svg>
                </div>
              </div>
            </div>
            <div class="mt10 rehab_list">
                <ListTable :headerItems="headerItems"
                           :itemRows="this.refinedExerciseListProps.length > 0 ? showRehabilitationList : ''"
                ></ListTable>
            </div>
            <div class="mt60 con_add" v-if="this.refinedExerciseListProps.length === 0">
                {{ $t('rehabilitation.no_list')}}
            </div>
        </div>
    </div>
</template>
<script>
    import moment from "moment";
    import ListTable from "../../../../Table/listTable/index";
    import {_STATUS_KEY_RANGE, _DATETIME_FORMAT} from '@/components/Table/static';
    import {mapActions} from "vuex"
    import _API from "@/api";
    
    export default {
        props: [
          'refinedExerciseListProps',
          'selectedRowsProps',
          'patientInfoProps',
        ],
        ref: 'fileInput',
        data() {
            return {
                headerItems: [
                    {
                        index: 0,
                        keyTitle: this.$t('title'),
                        keyType: 'HeaderDefault',
                        parentClass: [],
                        componentOptions: {},
                        keyRange: [],
                        values: '',
                    },
                    {
                        index: 1,
                        keyTitle: this.$t('status.status'),
                        keyType: 'HeaderDefault',
                        parentClass: [],
                        componentOptions: {},
                        keyRange: [],
                        values: '',
                    },
                    // {
                    //     index: 2,
                    //     keyTitle: this.$t('rehabilitation.mode'),
                    //     keyType: 'HeaderDefault',
                    //     class: [],
                    //     parentClass: [],
                    //     componentOptions: {},
                    //     keyRange: [],
                    //     values: '',
                    // },
                    // {
                    //     index: 2,
                    //     keyTitle: this.$t('rehabilitation.part'),
                    //     keyType: 'HeaderDefault',
                    //     class: [],
                    //     parentClass: [],
                    //     componentOptions: {},
                    //     keyRange: [],
                    //     values: '',
                    // },
                    // {
                    //     index: 4,
                    //     keyTitle: this.$t('rehabilitation.frequency'),
                    //     keyType: 'HeaderDefault',
                    //     class: [],
                    //     parentClass: [],
                    //     componentOptions: {},
                    //     keyRange: [],
                    //     values: '',
                    // },
                    // {
                    //     index: 5,
                    //     keyTitle: this.$t('rehabilitation.repeats'),
                    //     keyType: 'HeaderDefault',
                    //     class: [],
                    //     parentClass: [],
                    //     componentOptions: {},
                    //     keyRange: [],
                    //     values: '',
                    // },
                    {
                        index: 2,
                        keyTitle: this.$t('rehabilitation.due_date'),
                        keyType: 'HeaderDefault',
                        parentClass: [],
                        componentOptions: {},
                        keyRange: [],
                        values: '',
                    },
                ],

            }
        },
        components: {ListTable},
        methods: {
            ...mapActions(['getSelectedPatient']),
            selectExerciseRow(_e, seqExercise, i) {
                this.$emit('showSelectedRows', seqExercise, i);
            },
            openFileInput() {
              this.$refs.fileInput.click()
            },
            selectProtocolFile() {
                const file = event.target.files[0];

                if (file) {
                  const allowedExtensions = ["xlsx", "xls", "csv"];
                  const fileExtension = file.name.split('.').pop().toLowerCase();

                  if (allowedExtensions.includes(fileExtension)) {
                    this.readProtocol(file);
                    return;
                  }
                  alert('Please upload a valid Excel file (xlsx, xls, csv).');
                }
            },
            readProtocol(file) {
              const reader = new FileReader();

              reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);

                const ExcelJS = require('exceljs');
                const workbook = new ExcelJS.Workbook();

                workbook.xlsx.load(data)
                  .then(async () => {
                    const worksheet = workbook.getWorksheet(1);
                    const tasks = [];
                    worksheet.eachRow({ includeEmpty: false }, async (row, rowNumber) => {
                      if (rowNumber > 1) { // skip header
                        // At this point, suppose that clinians will upload valid data well.
                        // After internal testing, this should be modified below:
                        // - add validator for each value
                        // - add converter using existing structures such as enum,  data ranges, etc.
                        const exerciseData = {
                          "seqDeviceType": row.values[2] ?? 1,
                          "exerciseGuide": {
                            "exerciseGuideTitle": row.values[1] ?? "",
                            "exerciseGuideMode": row.values[3] ?? 0,
                            "exerciseGuidePosition": row.values[4] ?? 0,
                            "exerciseGuideHandGripType": row.values[5] ?? 0,
                            "exerciseGuideDeviceLoh": row.values[6] ?? 0,
                            "exerciseGuideDirection": row.values[7] ?? 0,
                            "exerciseGuideFlexion": row.values[8] ?? 0,
                            "exerciseGuideExtension": row.values[9] ?? 0,
                            "exerciseGuideFlexionDelayTime": row.values[10] ?? 0,
                            "exerciseGuideExtensionDelayTime": row.values[11] ?? 0,
                            "exerciseGuideFlexionLimitTime": row.values[12] ?? 0,
                            "exerciseGuideExtensionLimitTime": row.values[13] ?? 0,
                            "exerciseGuideSpeed": row.values[14] ?? 0,
                            "exerciseGuideMinRom": row.values[15] ?? 0,
                            "exerciseGuideMaxRom": row.values[16] ?? 0,
                            "exerciseGuideCount": row.values[17] ?? 0,
                            "exerciseGuideMuscleStiffSensitive": row.values[18] ?? 0,
                            "exerciseGuideTime": this.moment.duration(row.values[19], 'minutes').asSeconds() ?? 0,
                            "exerciseGuideContext": row.values[22] ?? "",
                          },
                          "exerciseSet": row.values[20] ?? 1,
                          "exerciseEndDatetime": this.moment(row.values[21]).format(_DATETIME_FORMAT),
                        };
                        tasks.push({
                          rowNumber,
                          exerciseData,
                        });
                      }
                    });
                    // Add an exercise sequantially.
                    // Because 'appendExerciesList' add to the top, so reverse the array.
                    tasks.sort((a, b) => b.rowNumber - a.rowNumber);
                    for (const task of tasks) {
                      const data = task.exerciseData;
                      //
                      this.activeSync = true;
                      let res = await this.getSelectedPatient();
                      data.seqMedicalRelation = res.patientInfo.seqMedicalRelation;
                      try {
                        res = await _API.EXERCISE_LIST.addExercise(data)
                        this.activeSync = false;
                        if (res.data.isSuccess === true && res.status === 200) {
                          this.$emit('appendExerciseList', data, res.data.insertId);
                        } else {
                          this.$modal.show('common-alert-modal', {
                            messageType: '',
                            message: ''
                          }); //define error
                        }
                      } catch (e) {
                        this.activeSync = false;
                        reject(`[addExercise] ${e}`);
                      };
                    }
                    this.$modal.show('common-alert-modal', {
                      messageType: 'short',
                      message: 'alert.add_completed'
                    });
                  }
                ).catch((err) => {
                  console.error(err);
                  alert('Please upload a valid Excel file first.');
                  return;
                });
              };

              reader.readAsArrayBuffer(file);

            },
            addExercise(data) {
              return new Promise((_resolve, reject) => {
                this.activeSync = true;
                this.getSelectedPatient().then(res => {
                  data.seqMedicalRelation = res.patientInfo.seqMedicalRelation;
                }).then(() => {
                  _API.EXERCISE_LIST.addExercise(data)
                      .then(res => {
                        this.activeSync = false;
                        if (res.data.isSuccess === true && res.status === 200) {
                          this.$modal.show('common-alert-modal', {
                            messageType: 'short',
                            message: 'alert.add_completed'
                          });
                          this.$emit('appendExerciseList', data, res.data.insertId);
                          this.$refs.InputBox.modalClose();
                        } else {
                          this.$modal.show('common-alert-modal', {
                            messageType: '',
                            message: ''
                          }); //define error
                        }
                      })
                }).catch(e => {
                  this.activeSync = false;
                  reject(`[addExercise] ${e}`);
                });
              });
            },

        },
        computed: {
            showRehabilitationList() {
                const itemRows = [];
                for (let i = 0; i < this.refinedExerciseListProps.length; i++) {
                    const items = [];
                    items.clickEvent = {
                        func: this.selectExerciseRow,
                        params: [this.refinedExerciseListProps[i].seqExercise, i],
                        key: this.refinedExerciseListProps[i].seqExercise
                    }
                    items.push({
                        index: 0,
                        keyTitle: '',
                        keyType: 'Default',
                        class: ['pointer'],
                        parentClass: [],
                        componentOptions: {},
                        keyRange: [],
                        values: this.refinedExerciseListProps[i].exerciseGuide.exerciseGuideTitle,
                    });
                    items.push({
                        index: 1,
                        keyTitle: '',
                        keyType: 'Default',
                        class: [_STATUS_KEY_RANGE[this.refinedExerciseListProps[i].exerciseStatus].class, 'pointer'],
                        parentClass: [],
                        componentOptions: {},
                        keyRange: '',
                        values: this.$t(`status.${_STATUS_KEY_RANGE[this.refinedExerciseListProps[i].exerciseStatus].title}`)
                    });
                    items.push({
                        index:2,
                        keyTitle: '',
                        keyType: 'Default',
                        class: ['pointer'],
                        parentClass: [],
                        componentOptions: {},
                        keyRange: [],
                        values: this.moment(this.refinedExerciseListProps[i].exerciseEndDatetime).locale(this.$t('country')).format('ll'),
                    });
                    itemRows.push(items);
                }
                return itemRows;
            },
        }
    }
</script>
<style lang="scss">
    .rehab_list_wrap {
        .right_add_list_btn {
            width: fit-content;
            display: block;
            float: right;
        }
    }
    .rehab_list {
        overflow: auto;
        max-height: 270px;

        .table-container {
            .table-header {
                position: sticky;
                top: 0;
                background: var(--grey10);
            }

            .table-header:hover {
                background: var(--grey10);
            }
        }
    }


    .con_add a {
        color: var(--blue70);
    }
</style>